//REACT-18
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <React.StrictMode>
//             <App />
//     </React.StrictMode>
// );
//REACT-17
import React, { Suspense } from "react";
import { render } from "react-dom";
import { Provider as ReduxProvider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import GlobalProvider from "./contexts/Provider";

// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';

// scroll bar
import 'simplebar/src/simplebar.css';
import './utils/highlight';
// editor
import 'react-quill/dist/quill.snow.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { AuthProvider } from './contexts/JWTContext';
import App from "./App";
import { store, persistor } from './redux/store';
// lightbox
import 'react-image-lightbox/style.css';
import "./i18nextConf";
// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const root = document.getElementById("root");


render(
    <Suspense fallback={null}>
        <HelmetProvider>
            <ReduxProvider store={store}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <SettingsProvider>
                        <CollapseDrawerProvider>
                            <GlobalProvider>
                                <AuthProvider>
                                    <App />
                                </AuthProvider>
                            </GlobalProvider>
                        </CollapseDrawerProvider>
                    </SettingsProvider>
                </LocalizationProvider>
            </ReduxProvider>
        </HelmetProvider >
    </Suspense>
    , root);

